/*
 * VT Slider Enhance — adds a synced dot-indicator row (mobile) to Dawn's
 * existing <slider-component> elements, replacing the numeric "1 / 6"
 * counter that vt-homepage.css hides. Desktop keeps the arrow buttons.
 *
 * Progressive enhancement only: if anything here fails, Dawn's native
 * slider (scroll + arrow buttons) keeps working exactly as before.
 */
(function () {
  function buildDots(sliderComponent, sliderButtons) {
    try {
      if (sliderButtons.querySelector('.vt-slider-dots')) return; // already done

      var totalEl = sliderButtons.querySelector('.slider-counter--total');
      var total = totalEl ? parseInt(totalEl.textContent, 10) : 0;
      if (!total || total < 2) return; // nothing to page through

      var dots = document.createElement('div');
      dots.className = 'vt-slider-dots';
      dots.setAttribute('role', 'tablist');

      for (var i = 0; i < total; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'vt-slider-dots__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === 0) dot.classList.add('is-active');
        (function (index) {
          dot.addEventListener('click', function () {
            goToPage(sliderComponent, index + 1);
          });
        })(i);
        dots.appendChild(dot);
      }

      sliderButtons.insertAdjacentElement('afterend', dots);
      sliderComponent.__vtDots = dots;
      sliderComponent.__vtDotTotal = total;
    } catch (e) {
      /* fail silently — native slider still works */
    }
  }

  function goToPage(sliderComponent, page) {
    try {
      if (!sliderComponent.slider || !sliderComponent.sliderItemOffset) return;
      var target = (page - 1) * sliderComponent.sliderItemOffset;
      sliderComponent.slider.scrollTo({ left: target, behavior: 'smooth' });
    } catch (e) {
      /* no-op */
    }
  }

  function setActive(sliderComponent, page) {
    try {
      var dots = sliderComponent.__vtDots;
      if (!dots) return;
      var children = dots.querySelectorAll('.vt-slider-dots__dot');
      children.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === page - 1);
      });
    } catch (e) {
      /* no-op */
    }
  }

  function initOne(sliderComponent) {
    try {
      if (sliderComponent.dataset.vtDotsInit === 'true') return;
      var sliderButtons = sliderComponent.querySelector('.slider-buttons');
      if (!sliderButtons) return;

      buildDots(sliderComponent, sliderButtons);
      sliderComponent.dataset.vtDotsInit = 'true';

      sliderComponent.addEventListener('slideChanged', function (event) {
        setActive(sliderComponent, event.detail.currentPage);
      });
    } catch (e) {
      /* fail silently for this slider, others keep working */
    }
  }

  function initAll() {
    document.querySelectorAll('slider-component').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme-editor re-renders a section without a full page reload.
  document.addEventListener('shopify:section:load', initAll);
})();
